import { DatePipe } from '@angular/common';
import { SimpleChanges } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EmployeeLeaveWidgetDataModel } from 'src/app/models/non-master-model/EmployeeLeaveWidgetDataModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { EmployeeLeaveService } from 'src/app/services/EmployeeLeave.service';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';

@Component({
  selector: 'app-employee-leave-widget',
  templateUrl: './employee-leave-widget.component.html',
  styleUrls: ['./employee-leave-widget.component.css']
})
export class EmployeeLeaveWidgetComponent implements OnInit {

  @Input() bookingSelectDate: string ="";

  TAG = "EmployeeLeaveWidgetComponent";
  
  constructor(
    readonly translate: TranslateService,
    private log: LoggerService,
    private employeeLeaveService: EmployeeLeaveService,
    public datepipe: DatePipe,
  ) {

    let currentLanguage = localStorage.getItem('currentLanguage');
    translate.use(currentLanguage);
  }

  employeeLeaveList: EmployeeLeaveWidgetDataModel[];

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
        
   // this.doSomething(changes.categoryId.currentValue);
    // You can also use categoryId.previousValue and 
    // categoryId.firstChange for comparing old and new values
    this.log.i(this.TAG,"changes Date = "+changes.bookingSelectDate.currentValue);

    this.getEmployeeLeaveDataByDate();
}


  getEmployeeLeaveDataByDate() {
    var selectedDate = this.bookingSelectDate = this.datepipe.transform(this.bookingSelectDate, 'yyyy-MM-dd');;
    this.employeeLeaveService.getEmployeeLeaveByDate(selectedDate,NavigationComponent.selectedShopID.toString()).subscribe(data => {
 
        this.employeeLeaveList = data;
    });

  }
}
